import React from 'react';

import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Table, NavLinkButton } from '@shared/components/bootstrap';

import { Panel } from '@admin/components/helpers/panel';
import { Permission } from '@admin/components/helpers/permission';
import { Spinner } from '@admin/components/spinner';
import { useTitle } from '@admin/hooks/use_title';
import { HIRING } from '@admin/libraries/access_control_catalog.generated';
import { client } from '@admin/libraries/apollo';
import { useHiringQuestionsQuery } from '@admin/schema';

export const HiringQuestionList: React.FC = () => {
  useTitle('Hiring | Pre-Screen Questions');
  const { data, loading } = useHiringQuestionsQuery({ client });

  return (
    <Panel>
      <Table responsive striped>
        <thead>
          <tr>
            <th>Question</th>
            <th>Answers</th>
            <th>Failing Answers</th>
            <th>Roles</th>
            <th className="text-right">
              <Permission resource={HIRING.resource} action={HIRING.actions.update} denied={null}>
                <NavLinkButton to="/hiring/pre_screen_questions/new" kind="mint">
                  <FontAwesomeIcon icon={faPlus} /> New
                </NavLinkButton>
              </Permission>
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.hiringQuestions.map((question) => (
            <tr key={question.id}>
              <td>{question.text}</td>
              <td>{question.options.join(', ')}</td>
              <td>{question.failingOptions.join(', ')}</td>
              <td>{question.jobs.map((job) => job.title).join(', ')}</td>
              <td className="text-right">
                <Permission resource={HIRING.resource} action={HIRING.actions.update} denied={null}>
                  <NavLinkButton to={`/hiring/pre_screen_questions/${question.id}/edit`} kind="primary">
                    Edit
                  </NavLinkButton>
                </Permission>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {loading && <Spinner />}
    </Panel>
  );
};
